module.exports = __webpack_public_path__ + "img/mark-pen.f15aec3.svg";